
const LetsTalk = () => {
	return (
		<>
			<h2 className='lets-talk'>Let's talk</h2>
		    <div className='links'>
		      <a className='link' href='https://twitter.com/_bablujunaid' target='_blank' rel="noreferrer"> <i className="fa-brands fa-twitter-square fa-2x logo"></i> </a>
		      <a className='link' href='https://www.linkedin.com/in/mdjunaid14/' target='_blank' rel="noreferrer"> <i className="fa-brands fa-linkedin fa-2x logo"></i> </a>
		      <a className='link' href='https://github.com/mdjunaid14' target='_blank' rel="noreferrer"> <i className="fa-brands fa-github-square fa-2x logo"></i> </a>
		      <a className='link' href='https://medium.com/@bablujunaid' target='_blank' rel="noreferrer"> <i className="fa-brands fa-medium fa-2x logo"></i> </a>
		    </div>
		</> 
	)
}

export default LetsTalk;